import part1 from './zh-part1.js'
import part2 from './zh-part2.js'
import part3 from './zh-part3.js'
import supplementZh from './faqSupplementZh.js'
import purchaseGuideZh from './faqPurchaseGuideZh.js'
import { processGeoFaq } from './faqCta.js'

function mergeFaqSupplements(key) {
  return [...(supplementZh[key] || []), ...(purchaseGuideZh[key] || [])]
}

export function mergeGeoContent(baseMessages) {
  const geo = { ...part1, ...part2, ...part3 }
  Object.keys(geo).forEach((key) => {
    const merged = { ...(baseMessages[key] || {}), ...geo[key] }
    if (merged.geoFaq) {
      merged.geoFaq = processGeoFaq(merged.geoFaq, key, 'CN', mergeFaqSupplements(key))
    }
    baseMessages[key] = merged
  })
  return baseMessages
}
